export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

export const getAuthUrl = (path: string) => `${API_URL}/auth${path}`;
export const getUserUrl = (path: string) => `${API_URL}/auth${path}`;

export const AUTH_ENDPOINTS = {
  register: () => getAuthUrl('/register'),
  login: () => getAuthUrl('/login'),
  logout: () => getAuthUrl('/logout'),
};

export const USER_ENDPOINTS = {
  me: () => getUserUrl('/me'),
}; 